/**
 * Shared prop vocabulary for the production foundation primitives. Alignment mirrors the
 * schema `Alignment`; ButtonVariant mirrors the schema `ActionStyle` so sections map
 * `Action.emphasis` straight through.
 */
import type { Alignment, ActionStyle } from '../../schema'

export type Align = Alignment // 'start' | 'center' | 'end'
export type ButtonVariant = ActionStyle // 'primary' | 'secondary' | 'ghost'
export type Tone = 'default' | 'alt' | 'dark'

/** Map an Alignment to its production modifier class suffix. */
export const ALIGN_CLASS: Record<Align, string> = {
  start: 'sbp-align-start',
  center: 'sbp-align-center',
  end: 'sbp-align-end',
}
